<template>
    <aside class="min-h-screen bg-infill-white px-10">
        <ul class="sticky top-[80px] list-none m-0 py-12">
            <li v-for="(step, index) in stepper.steps" :key="index" class="uppercase mb-8">
                <a :href="'#' + step.admin_anchor_link" class="flex items-center no-underline text-deep-blue">
                    <img
                        v-if="step.admin_icon"
                        class="mr-2"
                        :src="global.app.url + '/images/icons/steps/' + step.admin_icon + '.svg'"
                        :alt="step.label + ' icon'"
                        :title="step.label"
                    />
                    <h2 class="text-[14px]">{{ step.admin_label }}</h2>
                </a>
            </li>
        </ul>
    </aside>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "SidebarComponent",
    components: {},
    computed: {
        ...mapGetters(["global", "stepper"]),
    },
    data: function () {
        return {
            isLoading: false,
        };
    },
    methods: {
        // ...mapActions([""]),
    },
};
</script>
